import React, { FC, useMemo, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import _sortBy from 'lodash/sortBy';
import { useDrawerSearchFilterNameOrCategory, useDrawerFiltersCounts, useDrawerGlobalLoader } from '@minecraft.drawer';
import ErrorMessage from '@minecraft.error-message';
import {
  FormItem,
  useFiltersLabel,
  generateSelectOptionsBasedOnField,
  FiltersNameEnum,
  FilterDrawerType,
} from '@blocs.filter';
import { FiltersCategoryNameEnum, FiltersCountNameEnum } from '../../shared/types';
import { HairColor } from '../../FilterDrawerCollection';
import { QUERY_HAIR_COLORS } from './HairColorCategoryGraphQL';

interface Props {
  type: FilterDrawerType;
}

const HairColorCategory: FC<Props> = ({ type }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);

  const { data, error, loading } = useQuery(QUERY_HAIR_COLORS);

  const { isCategoryMatchedSearch, assignOptionsToCategoryFilters } = useDrawerSearchFilterNameOrCategory(
    FiltersCategoryNameEnum.hairColor
  );
  const { filtersCounts } = useDrawerFiltersCounts();

  const hairColorOptions = useMemo(() => {
    return generateSelectOptionsBasedOnField(
      _sortBy(data?.hairColors, 'name'),
      'name',
      false,
      filtersCounts?.[FiltersCountNameEnum.hairColorId]
    );
  }, [data, filtersCounts]);

  useDrawerGlobalLoader(loading);

  useEffect(() => {
    if (hairColorOptions.length > 0) {
      assignOptionsToCategoryFilters({
        [FiltersNameEnum.hairColor]: hairColorOptions,
      });
    }
  }, [hairColorOptions]);

  if (error) {
    return <ErrorMessage error={error} />;
  }

  return (
    isCategoryMatchedSearch && (
      <FormItem $fullWidth $marginValue={2}>
        <HairColor
          willingToChange={{
            name: FiltersNameEnum.willingToHairColor,
            label: filtersLabelOfAudience[FiltersNameEnum.willingToHairColor],
          }}
          hairColor={{
            name: FiltersNameEnum.hairColor,
            label: filtersLabelOfAudience[FiltersNameEnum.hairColor],
          }}
        />
      </FormItem>
    )
  );
};

export default HairColorCategory;
